export type CampaignTabItem = { value: string; label: string; count?: string | number };

export function CampaignTabs({ items, value, onChange }: { items: CampaignTabItem[]; value: string; onChange: (value: string) => void }) {
  return <div className="tabs campaign-section-tabs" role="tablist" aria-label="Secciones de campaña">
    {items.map((item, index) => <button key={item.value} type="button" role="tab" className={value === item.value ? "active" : ""} aria-selected={value === item.value} tabIndex={value === item.value ? 0 : -1} aria-controls={`campaign-section-${item.value}`} onClick={() => onChange(item.value)} onKeyDown={(event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
      event.preventDefault();
      const offset = event.key === "ArrowRight" ? 1 : -1;
      const next = items[(index + offset + items.length) % items.length]!;
      onChange(next.value);
      requestAnimationFrame(() => document.querySelector<HTMLElement>(`[role="tab"][aria-controls="campaign-section-${next.value}"]`)?.focus());
    }}><span>{item.label}</span>{item.count !== undefined && <span className="tab-count">{item.count}</span>}</button>)}
  </div>;
}
